/**
 * Lightweight, PII-free platform/browser bucket detection for PWA tracking.
 *
 * Returns a coarse-grained bucket (e.g. "android-chrome", "ios-safari", "desktop-chrome")
 * derived solely from navigator.userAgent. No fingerprinting, no version numbers
 * forwarded, no IP, no email, no device ID. Safe to put inside funnel_events.
 */
const ANDROID = /android/i;
const IPHONE_IPAD = /iphone|ipad|ipod/i;
const SAFARI = /safari/i;
const CHROME = /chrome|crios/i;
const FIREFOX = /firefox|fxios/i;
const EDGE = /edg/i;

export function getPlatformBucket() {
  if (typeof navigator === 'undefined') return 'unknown';
  const ua = (navigator.userAgent || '').toLowerCase();

  let os = 'desktop';
  if (ANDROID.test(ua)) os = 'android';
  else if (IPHONE_IPAD.test(ua)) os = 'ios';
  else if (/windows/i.test(ua)) os = 'windows';
  else if (/mac os/i.test(ua)) os = 'mac';
  else if (/linux/i.test(ua)) os = 'linux';

  let browser = 'other';
  // Order matters: Edge ships with "Chrome" in UA, Chrome ships with "Safari".
  if (EDGE.test(ua)) browser = 'edge';
  else if (FIREFOX.test(ua)) browser = 'firefox';
  else if (CHROME.test(ua)) browser = 'chrome';
  else if (SAFARI.test(ua)) browser = 'safari';

  return `${os}-${browser}`;
}

export function isStandaloneDisplay() {
  if (typeof window === 'undefined') return false;
  try {
    if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) return true;
    if (window.navigator.standalone === true) return true;
  } catch (e) { /* ignore */ }
  return false;
}
